export default __webpack_public_path__ + "static/media/building.b6f83b55.png";